<template>
  <div class="contactdiv">
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>关于我们</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form ref="form" :model="contForm">

      <el-form-item label="LOGO" :rules="[
          { required: true, message: '不能为空'},
        ]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          :headers='headers'
          :show-file-list=false
          :on-success="upImgSuccess"
          multiple
          :limit="3">
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
        </el-upload>
        <div class="QR-code">
          <img width="100%" :src="contForm.imgUrl" alt="">
        </div>
      </el-form-item>
      
      <el-form-item label="电话" :rules="[
        { required: true, message: '电话不能为空'},
        { type: 'number', message: '电话必须为数字值'}]">
        <el-input v-model.number="contForm.tel"></el-input>
      </el-form-item>
      
      <el-form-item label="地址" :rules="[
        { required: true, message: '地址不能为空'},]">
        <el-input maxlength="37" placeholder="最多不能超过37个字符" v-model="contForm.address"></el-input>
      </el-form-item>

      <el-form-item label="英文地址" :rules="[
        { required: true, message: '地址不能为空'},]">
        <el-input maxlength="1000" v-model="contForm.address_en"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" :rules="[
        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
        <el-input v-model="contForm.email"></el-input>
      </el-form-item>

      <el-form-item label="标语" :rules="[
        { required: true, message: '标语不能为空'},]">
        <el-input maxlength="37" placeholder="" v-model="contForm.title"></el-input>
      </el-form-item>

       <el-form-item label="英文标语" :rules="[
        { required: true, message: '标语不能为空'},]">
        <el-input maxlength="5000"  v-model="contForm.title_en"></el-input>
      </el-form-item>
      
      <el-form-item label="业务概览" :rules="[
        { required: true, message: '业务概览不能为空'},]">
        <el-input type="textarea" placeholder="" v-model="contForm.overview"></el-input>
      </el-form-item>

      <el-form-item label="英文概览" :rules="[
        { required: true, message: '英文业务概览不能为空'},]">
        <el-input type="textarea" placeholder="" v-model="contForm.overview_en"></el-input>
      </el-form-item>

      <el-form-item label="使命" :rules="[
        { required: true, message: '使命不能为空'},]">
        <el-input maxlength="37" placeholder="" v-model="contForm.mission"></el-input>
      </el-form-item>

      <el-form-item label="英文使命" :rules="[
        { required: true, message: '英文使命不能为空'},]">
        <el-input maxlength="1000" placeholder="" v-model="contForm.mission_en"></el-input>
      </el-form-item>
     
      <el-form-item label="愿景" :rules="[
        { required: true, message: '愿景不能为空'},]">
        <el-input maxlength="37" placeholder="" v-model="contForm.vision"></el-input>
      </el-form-item>

      <el-form-item label="英文愿景" :rules="[
        { required: true, message: '英文愿景不能为空'},]">
        <el-input maxlength="1000" placeholder="" v-model="contForm.vision_en"></el-input>
      </el-form-item>

      
      <!-- <el-form-item label="地图">
        <p style="text-align:left;margin-top:0;">{{location}}</p>
        <div class="map" id="map"></div>
      </el-form-item>

      <el-form-item label="地图内容" :rules="[
          { required: true, message: '不能为空'},
        ]">
        <el-input v-model="contForm.mapContent"></el-input>
      </el-form-item> -->

      
    </el-form>

     <el-button type="primary" @click="save">保存</el-button>
    <Backfooter></Backfooter>
  </div>
</template>
<script>
import Backfooter from '../../components/dashu/backfooter';
export default {
  components:{Backfooter,},
  data() {
    return {
      contForm: {
        tel: '',
        address: '',
        address_en: '',
        email: '',
        imgUrl: '',
        id: '',
        mission: '',
        mission_en: '',
        overview: '',
        overview_en: '',
        title_en: '',
        vision: '',
        vision_en: ''
      },
      location: '',

      headers: {
        Authorization: ''
      }
    }
  },
  methods: {
    upImgSuccess(response) {
      // console.log(response)
      this.contForm.imgUrl =
        'https://api.treegroup-inc.com/' + response.data.url
      // console.log(this.contForm.imgUrl)
    },
    save() {
      this.$http
        .post('/admin/dashu/about/update', {
          id: this.contForm.id,
          title: this.contForm.title,
          overview: this.contForm.overview,
          mission: this.contForm.mission,
          address: this.contForm.address,
          email: this.contForm.email,
          logo: this.contForm.imgUrl,
          vision: this.contForm.vision,
          telphone: this.contForm.tel,
          titleEn: this.contForm.title_en,
          overviewEn: this.contForm.overview_en,
          missionEn: this.contForm.mission_en,
          visionEn: this.contForm.vision_en,
          addressEn: this.contForm.address_en,
        })
        .then(res => {
          var code = res.data.code
          if (code === 0) {
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
          } else if (code === -1) {
            this.$message.error('请检查是否填写完整！')
          }
        })
        .catch(function(error) {
          //  console.log(error);
        })
    }
  },
  created() {
    this.headers.Authorization = window.localStorage.getItem('user_token')
    this.$http
      .post('/admin/dashu/about/aboutList', {})
      .then(res => {
        // console.log(res.data.data.lists)
        var code = res.data.code
        if (code === 0) {
          // console.log(res.data.code)
          this.contForm.tel = res.data.data.lists[0].telphone
          this.contForm.address = res.data.data.lists[0].address
          this.contForm.email = res.data.data.lists[0].email
          this.contForm.id = res.data.data.lists[0].id
          this.contForm.imgUrl = res.data.data.lists[0].logo
          this.contForm.mission = res.data.data.lists[0].mission
          this.contForm.overview = res.data.data.lists[0].overview
          this.contForm.title = res.data.data.lists[0].title
          this.contForm.vision = res.data.data.lists[0].vision
          //  console.log(this.contForm);
          this.contForm.title_en = res.data.data.lists[0].title_en
          this.contForm.overview_en = res.data.data.lists[0].overview_en
          this.contForm.mission_en = res.data.data.lists[0].mission_en
          this.contForm.vision_en = res.data.data.lists[0].vision_en
          this.contForm.address_en = res.data.data.lists[0].address_en
        }
      })
      .catch(function(error) {
        //  console.log(error);
      })
  },
  mounted() {}
}
</script>
<style scoped>
.map {
  width: 800px;
  height: 500px;
} 
.QR-code img{
  width: 100px;
  /* height: 100px; */
}
.contactdiv{
    position: relative;
    padding-bottom:100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/backPages/contact.vue